import { get, post } from "./client";

export type VerifiedUser = {
  externalId: string;
  firmRef: string;
  firmName: string;
};

export type NormalizeSubmissionsResponse = {
  message: string;
  updatedSubmissions: number;
  updatedDocumentFiles: number;
  updatedRefereeFiles: number;
  skippedSubmissions?: number;
};

export type UserWithUnverifiedFiles = {
  externalId: string;
  email: string;
  firms: { firmRef: string; firmName: string }[];
  unverifiedFileCount: number;
  unverifiedSubmissionCount: number;
  submissionsWithoutFirmRefCount: number;
};

async function getVerifiedUsersWithFirms(): Promise<{ users: VerifiedUser[] }> {
  return get("/v1/developer/users/verified-with-firms");
}

async function getUsersWithUnverifiedFiles(): Promise<{ users: UserWithUnverifiedFiles[] }> {
  return get("/v1/developer/users/with-unverified-files");
}

async function normalizeSubmissions(params: {
  userId: string;
  firmRef: string;
  firmName: string;
  force?: boolean;
}): Promise<NormalizeSubmissionsResponse> {
  return post("/v1/developer/users/normalize-submissions", params);
}

export type MoveToFirmResponse = {
  frontegg: {
    userId: string;
    firmRef: string;
  };
  submissions: NormalizeSubmissionsResponse;
};

async function moveUserToFirm(params: {
  userId: string;
  firmRef: string;
  firmName: string;
  fromFirmRefs?: string[];
}): Promise<MoveToFirmResponse> {
  return post("/v1/developer/users/move-to-firm", params);
}

export const developerUsersService = {
  getVerifiedUsersWithFirms,
  getUsersWithUnverifiedFiles,
  normalizeSubmissions,
  moveUserToFirm,
};
